import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BehaviorSubject, catchError, map, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private rowDataSubject = new BehaviorSubject<any>(null);
  rowData$ = this.rowDataSubject.asObservable();
  private fleetViewRowDataSubject = new BehaviorSubject<any>(null);
  fleetViewRowData$ = this.fleetViewRowDataSubject.asObservable();
  private filterDataSubject = new BehaviorSubject<any>(null);
  filterData$ = this.filterDataSubject.asObservable();
  private periodicRowDataSubject = new BehaviorSubject<any>(null);
  periodicRowData$ = this.periodicRowDataSubject.asObservable();
  private shipNameSubject = new BehaviorSubject<string | null>(null);
  shipName$ = this.shipNameSubject.asObservable();

  private totalsSubject = new BehaviorSubject<any>({
    cp: 0,
    design: 0,
  });

  totals$ = this.totalsSubject.asObservable();
   private selectedImoSource = new BehaviorSubject<string | null>(null);
  selectedImo$ = this.selectedImoSource.asObservable();



  private readonly baseUrl = environment.apiBaseUrl;
  constructor(
    private http: HttpClient,
    private ngxService: NgxUiLoaderService,
  ) { }
  updateTotals(totals: any) {
    this.totalsSubject.next(totals);
  }
  setperiodicRowDat(rowData: any) {
    this.periodicRowDataSubject.next(rowData);
  }
  setFleetViewRowDat(rowData: any) {
    this.fleetViewRowDataSubject.next(rowData);
  }
  setFilterData(filterData: any) {
    this.filterDataSubject.next(filterData);
  }
  setRowData(rowData: any) {
    this.rowDataSubject.next(rowData);
  }
  getRowData() {
    return this.rowDataSubject.value;
  }
  setShipName(shipName: string) {
    this.shipNameSubject.next(shipName);
  }

    setSelectedImo(imo: any) {
    this.selectedImoSource.next(imo);
  }
  getShipName() {
    return this.shipNameSubject.value;
  }

  getClients(): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/scperformance/client`
    );
  }
  getAisEtaTable(username: any) {

    const url =
      `${this.baseUrl}/scperformance/vessel-eta-list?username=${username}`;

    return this.http
      .get<any>(url)
      .pipe(catchError(this.errorHandler));

  }
  // add data
  getFleetView(body: any) {
    const url = `${this.baseUrl}/scperformance/fleet`;
    return this.http.post<any>(url, body).pipe(catchError(this.errorHandler));
  }
  //  getFleetViewSummary(body: any) {
  //   const url = `${this.baseUrl}/`;
  //   return this.http.post<any>(url, body).pipe(catchError(this.errorHandler));
  // }
  getFleetViewSummary(params: any) {
    const url = `${this.baseUrl}/scperformance/fleet-view`;

    return this.http
      .get<any>(url, {
        params,
        headers: { 'X-Skip-Ngx-Ui-Loader': 'true' }
      })
      .pipe(catchError(this.errorHandler));
  }

  getVesselView(
    shipName: any,
    segment: any,
    vessel_status: any,
    from_date_str: any,
    to_date_str: any,
    condition: any,
    voyNumber: any,
    page: any,
  ) {
    const url = `${this.baseUrl}/scperformance/vessel?vessel_name=${shipName}&segment=${segment}&vessel_status=${vessel_status}&from_date=${from_date_str}&to_date=${to_date_str}&condition=${condition}&voyage_id=${voyNumber}&page=${page}`;
    return this.http.get<any>(url).pipe(catchError(this.errorHandler));
  }
  getDetailedViewTable(payload: any) {
    const url = `${this.baseUrl}/scperformance/vessel-voyages`;
    return this.http
      .post<any>(url, payload)
      .pipe(catchError(this.errorHandler));
  }

  postFormDetails(body: any) {
    const url = `${this.baseUrl}`;
    return this.http.post(url, body).pipe(catchError(this.errorHandler));
  }
  postClaimEstimate(body: any) {
    const url = `${this.baseUrl}/scperformance/update_claim_estimate`;
    return this.http.post(url, body).pipe(catchError(this.errorHandler));
  }
  updateStatus(body: any) {
    const url = `${this.baseUrl}/scperformance/vessel_status_update`;
    return this.http
      .post(url, body, { responseType: 'text' })
      .pipe(catchError(this.errorHandler));
  }
  getData(): Observable<any[]> {
    const url = `assets/dummyData.json`;
    return this.http.get<any>(url);
  }
  // Legacy: fetched all 22k rows at once — replaced by getLookerStats + getLookerData
  getDatabase() {
    const url = `${this.baseUrl}/scperformance/looker_studio`;
    return this.http.get(url, { responseType: 'text' }).pipe(
      map((responseText) => {
        const sanitizedText = responseText
          .replace(/:\s*NaN/g, ': null')
          .replace(/:\s*Infinity/g, ': null')
          .replace(/:\s*-Infinity/g, ': null');
        return JSON.parse(sanitizedText);
      }),
      catchError(this.errorHandler),
    );
  }

  /** Returns aggregate counts (total voyages, vessels, underperformance, etc.) */
  getLookerStats(username: string, filters: any = {}): Observable<any> {
    let params = new HttpParams().set('username', username);
    if (filters) {
      Object.keys(filters).forEach(key => {
        const val = filters[key];
        if (val !== undefined && val !== null && val !== '') {
          if (Array.isArray(val)) {
            val.forEach(v => params = params.append(`${key}[]`, v));
          } else {
            params = params.set(key, val);
          }
        }
      });
    }
    const url = `${this.baseUrl}/scperformance/looker-studio-stats`;
    return this.http
      .get<any>(url, { params, headers: { 'X-Skip-Ngx-Ui-Loader': 'true' } })
      .pipe(catchError(this.errorHandler));
  }

  /** Returns paginated voyage data — 100-500 rows per page */
  getLookerData(username: string, page: number = 1, filters: any = {}): Observable<any> {
    let params = new HttpParams()
      .set('username', username)
      .set('page', page.toString());

    if (filters) {
      Object.keys(filters).forEach(key => {
        const val = filters[key];
        if (val !== undefined && val !== null && val !== '') {
          if (Array.isArray(val)) {
            val.forEach(v => params = params.append(`${key}[]`, v));
          } else {
            params = params.set(key, val);
          }
        }
      });
    }

    const url = `${this.baseUrl}/scperformance/looker-studio-data`;
    return this.http.get(url, { params, responseType: 'text' }).pipe(
      map((responseText) => {
        const sanitizedText = responseText
          .replace(/:\s*NaN/g, ': null')
          .replace(/:\s*Infinity/g, ': null')
          .replace(/:\s*-Infinity/g, ': null');
        return JSON.parse(sanitizedText);
      }),
      catchError(this.errorHandler),
    );
  }

  /** Returns all rows with only the 7 chart-needed columns — single call, no pagination */
getLookerChartData(
  username: string,
  filters: any = {}
): Observable<any[]> {

  let url =
    `${this.baseUrl}/scperformance/looker-studio-chart-data` +
    `?username=${encodeURIComponent(username)}`;

  const filterParams = [
    'clientStatus',
    'from_date',
    'to_date',
    'reportfrom_date',
    'reportto_date',
    'condition',
    'vesselName',
    'vesselStatus',
    'client',
    'segment',
    'type_of_ship',
    'type_speed',
    'technical_operator',
    'commercial_operator'
  ];

  filterParams.forEach((key) => {

    const value = filters[key];

    // Ignore null, undefined or empty values
    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {
      return;
    }

    // --------------------------------------------------
    // MULTI SELECT
    // Example:
    // client: ['ALGHAF', 'ZeroNorth']
    // Sends:
    // &client=ALGHAF&client=ZeroNorth
    // --------------------------------------------------
    if (Array.isArray(value)) {

      value.forEach((item) => {

        if (
          item !== null &&
          item !== undefined &&
          item !== ''
        ) {

          url +=
            `&${key}=${encodeURIComponent(item)}`;
        }

      });

    }

    // --------------------------------------------------
    // SINGLE SELECT
    // --------------------------------------------------
    else {

      url +=
        `&${key}=${encodeURIComponent(value)}`;
    }

  });

  return this.http
    .get<any[]>(
      url,
      {
        headers: {
          'X-Skip-Ngx-Ui-Loader': 'true'
        }
      }
    )
    .pipe(
      catchError(this.errorHandler)
    );
}

  /** Returns available segments for Laden/Ballast */
  getLookerSegments(username: string): Observable<any> {
    const url = `${this.baseUrl}/scperformance/looker-studio-segments`;
    const params = new HttpParams().set('username', username);
    const headers = new HttpHeaders().set('X-Skip-Ngx-Ui-Loader', 'true');
    return this.http.get(url, { params, headers }).pipe(catchError(this.errorHandler));
  }

  getLookerVessels(username: string, options?: { active_only?: boolean; exclude_zeronorth?: boolean }): Observable<any> {
    const url = `${this.baseUrl}/scperformance/looker-studio-vessels`;
    let params = new HttpParams().set('username', username);
    if (options?.active_only) {
      params = params.set('active_only', 'true');
    }
    if (options?.exclude_zeronorth) {
      params = params.set('exclude_zeronorth', 'true');
    }
    const headers = new HttpHeaders().set('X-Skip-Ngx-Ui-Loader', 'true');
    return this.http.get(url, { params, headers }).pipe(catchError(this.errorHandler));
  }

  /** Single precomputed payload for the /#/home landing page (fleet table,
   * stat cards, segments, both charts, ETA table) — served from a cache
   * table, replaces 5 separate live calls. Refreshed twice daily by a
   * backend cron, or on demand via resyncHomeDashboard. */
  getHomeDashboard(username: string, subusername?: string): Observable<any> {
    const url = `${this.baseUrl}/scperformance/home-dashboard`;
    let params = new HttpParams().set('username', username);
    if (subusername) {
      params = params.set('subusername', subusername);
    }
    return this.http.get<any>(url, { params }).pipe(catchError(this.errorHandler));
  }

  /** Any fleet-view page beyond page 1 — served from the same cache row as
   * getHomeDashboard, just sliced server-side, so it's still cache-fast. */
  getFleetViewPage(username: string, page: number, subusername?: string): Observable<any> {
    const url = `${this.baseUrl}/scperformance/home-dashboard/fleet-view`;
    let params = new HttpParams()
      .set('username', username)
      .set('page', page.toString());
    if (subusername) {
      params = params.set('subusername', subusername);
    }
    return this.http.get<any>(url, { params }).pipe(catchError(this.errorHandler));
  }

  /** Triggers an on-demand refresh of the home-dashboard cache, scoped to
   * exactly this username's client (Meraki users resync Meraki's row,
   * EMZoil users resync EMZoil's row, etc). Runs synchronously server-side
   * and can take a few minutes — call getHomeDashboard again afterwards to
   * pick up the fresh data. */
  resyncHomeDashboard(username: string, subusername?: string): Observable<any> {
    const url = `${this.baseUrl}/scperformance/home-dashboard/resync`;
    let params = new HttpParams().set('username', username);
    if (subusername) {
      params = params.set('subusername', subusername);
    }
    return this.http
      .post<any>(url, {}, { params })
      .pipe(catchError(this.errorHandler));
  }

  /** Cascading filter options for Speed & Consumption Database */
  getLookerFilterOptions(payload: Record<string, unknown> = {}): Observable<any> {
    const url = `${this.baseUrl}/scperformance/looker-studio-filter-options`;
    return this.http
      .post<any>(url, payload, { headers: { 'X-Skip-Ngx-Ui-Loader': 'true' } })
      .pipe(catchError(this.errorHandler));
  }

  /** NEW DEDICATED VP Fleet Performance Chart Data call */
  getVpFleetPerformanceChartData(
    username: string,
    filters: any = {}
  ): Observable<any[]> {
    let url =
      `${this.baseUrl}/scperformance/vp-fleet-performance/chart-data` +
      `?username=${encodeURIComponent(username)}`;

    const filterParams = [
      'clientStatus',
      'from_date',
      'to_date',
      'reportfrom_date',
      'reportto_date',
      'condition',
      'vesselName',
      'vesselStatus',
      'client',
      'segment',
      'type_of_ship',
      'type_speed',
      'weather',
      'apply_current_factor',
      'apply_weather_factor',
      'technical_operator',
      'commercial_operator',
      'limit',
      'page_size',
    ];

    filterParams.forEach((key) => {
      const value = filters[key];
      if (value === null || value === undefined || value === '') return;

      if (Array.isArray(value)) {
        value.forEach((item) => {
          if (item !== null && item !== undefined && item !== '') {
            url += `&${key}=${encodeURIComponent(item)}`;
          }
        });
      } else {
        url += `&${key}=${encodeURIComponent(value)}`;
      }
    });

    return this.http
      .get<any[]>(url, { headers: { 'X-Skip-Ngx-Ui-Loader': 'true' } })
      .pipe(catchError(this.errorHandler));
  }

  /** NEW DEDICATED VP Fleet Performance Filter Options call */
  getVpFleetPerformanceFilterOptions(payload: Record<string, unknown> = {}): Observable<any> {
    const url = `${this.baseUrl}/scperformance/vp-fleet-performance/filter-options`;
    return this.http
      .post<any>(url, payload, { headers: { 'X-Skip-Ngx-Ui-Loader': 'true' } })
      .pipe(catchError(this.errorHandler));
  }


  getRemarks(body: any) {
    const url = `${this.baseUrl}/scperformance/get_vessel_comment`;
    return this.http.post<any>(url, body).pipe(catchError(this.errorHandler));
  }
  postRemarks(body: any) {
    const url = `${this.baseUrl}/scperformance/insert_vessel_comment`;
    return this.http.post<any>(url, body).pipe(catchError(this.errorHandler));
  }
  getAllComments() {
    const url = `${this.baseUrl}/scperformance/get_all_vessel_comment`;
    return this.http.get<any>(url).pipe(catchError(this.errorHandler));
  }

  getPeriodicSummary(body: any) {
    const url = `${this.baseUrl}/scperformance/periodic_summary_input`;
    let params = new HttpParams();
    Object.keys(body).forEach((key) => {
      if (body[key] !== undefined && body[key] !== null) {
        params = params.set(key, body[key]);
      }
    });

    return this.http
      .get<any>(url, { params })
      .pipe(catchError(this.errorHandler));
  }
  updatePeriodicSummaryRow(body: any): Observable<any> {
    const url = `${this.baseUrl}/scperformance/periodic_summary_update`;
    return this.http.post<any>(url, body).pipe(catchError(this.errorHandler));
  }

  generatePeriodicSummaryPdf(body: any): Observable<Blob> {
    const url = `${this.baseUrl}/scperformance/periodic_summary_pdf`;
    return this.http.post(url, body, { responseType: 'blob' });
  }
  getTcpData(body: any) {
    const url = `${this.baseUrl}/api/snc_tcp_bench_marking`;
    return this.http.post<any>(url, body).pipe(catchError(this.errorHandler));
  }
  downloadMasterReport(jsonData: any): Observable<Blob> {
    const url = `${this.baseUrl}/scperformance/download_master_report_excel_file`;

    return this.http
      .post(url, jsonData, { responseType: 'blob' })
      .pipe(catchError(this.errorHandler));
  }

  downloadSeaReportCsv(imo: string, start: string, end: string, voyagePhase?: string): Observable<Blob> {
    let url = `${this.baseUrl}/scperformance/performance_calc_csv/${imo}?start=${start}&end=${end}`;
    if (voyagePhase && voyagePhase !== 'both') {
      url += `&voyagePhase=${voyagePhase}`;
    }
    return this.http.get(url, { headers: { 'X-Skip-Ngx-Ui-Loader': 'true' }, responseType: 'blob' }).pipe(catchError(this.errorHandler));
  }

  toggleVesselStatus(body: any) {
    const url = `${this.baseUrl}/api/vessel/toggle-status`;
    return this.http
      .post<any>(url, body)
      .pipe(catchError(this.errorHandler));
  }


generateAIResponse(question: string, file?: File,history: any[] = []): Observable<any> {
  const url = `${this.baseUrl}/scperformance/disbursement_chatbot`;

  const formData = new FormData();

  formData.append('question', question);
    formData.append(
    'history',
    JSON.stringify(history)
  );
  if (file) {
    formData.append('file', file);
  }

  return this.http
    .post<any>(url, formData)
    .pipe(catchError(this.errorHandler));
}
getExchangeRates() {
  const url = `${this.baseUrl}/scperformance/exchange-rates`;
  return this.http.get<any>(url).pipe(
    catchError(this.errorHandler)
  );
}
  errorHandler(error: HttpErrorResponse) {
    return throwError(() => error || 'Server Error');
  }
}
